import Input, { TextArea, Search, Password } from "./Input";
Input.TextArea = TextArea;
Input.Search = Search;
Input.Password = Password;
export default Input;